import { IconLike16, UIText2, IconDislike16 } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './ClientReaction.css';
import { ELikeDislikeReaction } from '../../repositories/favorites/entities/favorite_entity_for_desktop/ClientReactionsToOfferSchema';

interface IClientReactionProps {
  likeDislikeReaction: ELikeDislikeReaction;
  isSearcherOrSub: boolean;
}

export const ClientReaction = ({ likeDislikeReaction, isSearcherOrSub }: IClientReactionProps) => {
  return likeDislikeReaction === 'like' ? (
    <div {...mergeStyles(styles['reaction'], styles['like'])}>
      <IconLike16 color="current_color" />
      <UIText2 color="current_color">{isSearcherOrSub ? 'Нравится' : 'Нравится клиенту'}</UIText2>
    </div>
  ) : (
    <div {...mergeStyles(styles['reaction'], styles['dislike'])}>
      <IconDislike16 color="current_color" />
      <UIText2 color="current_color">{isSearcherOrSub ? 'Не нравится' : 'Не нравится клиенту'}</UIText2>
    </div>
  );
};
